import PropTypes from 'prop-types';

import { Form, Button, Input } from 'antd';
import { AntButton } from '@/common/ant-components/AntButton';
import { CrownOutlined, LockOutlined, UserOutlined } from '@ant-design/icons';

const SuperAdminLogin = ({
  validateMobileNumber,
  firstInputRef,
  loading,
  handleLogin,
}) => {
  return (
    <>
      <div className="superadmin-badge">
        <CrownOutlined /> Super Admin
      </div>
      <Form
        initialValues={{ remember: true }}
        onFinish={(value) => handleLogin('superadmin/login/', value)}
        className="modern-login-form"
        layout="vertical"
      >
        <Form.Item
          name="mobileNumber"
          label="Username"
          className="username"
          validateTrigger="onChange"
          rules={[
            {
              required: true,
              message: 'Please input your super admin username!',
            },
          ]}
        >
          <Input
            // maxLength={10}
            ref={firstInputRef}
            placeholder="username"
            prefix={<UserOutlined className="input-icon" />}
            size="large"
            className="modern-input"
          />
        </Form.Item>

        <Form.Item
          name="password"
          label={<span className="form-label">Password</span>}
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password
            placeholder="Enter super admin password"
            prefix={<LockOutlined className="input-icon" />}
            className="modern-input"
            size="large"
          />
        </Form.Item>

        <Form.Item>
          <AntButton
            className="modern-submit-button"
            htmlType="submit"
            disabled={loading}
            loading={loading}
            block
            size="large"
          >
            {loading ? 'Signing in...' : 'Super Admin Sign In'}
          </AntButton>
        </Form.Item>
      </Form>
    </>
  );
};

SuperAdminLogin.propTypes = {
  navigate: PropTypes.func,
  firstInputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  validateMobileNumber: PropTypes.func,
  loading: PropTypes.bool,
  handleLogin: PropTypes.func,
};

export default SuperAdminLogin;
